module.exports = __webpack_public_path__ + "img/greet_body.56f28e98.png";